/**
 * File product-info-tabs.js.
 *
 * Handles product info tabs block.
 */
(function ($) {
    'use strict';

    $(document).ready(function () {
        sliderInit();
        $(window).on('resize', function(){
            sliderInit();
        });

        $(document).on('click', '.product-info-tabs .product-info-tabs__wrap .tab-list a', function(){
            let targetAttr = $(this).attr('data-tab-related');
            $(this).parent('li').addClass('active').siblings().removeClass('active');
            $(this).parents('.product-info-tabs').find('.product-info-tabs__body .product-info-tab-inner__content[data-tab-content="' + targetAttr + '"]').addClass('active').siblings().removeClass('active');
        });

        $(this).find('.product-info-tabs__wrap .tab-list .slick-prev').on('click', function(){
            $(this).parents('.tab-list').find('.slick-slide.active:not(:first-child)').removeClass('active').prev().addClass('active').find('a').trigger('click');
        });
        $(this).find('.product-info-tabs__wrap .tab-list .slick-next').on('click', function(){
            $(this).parents('.tab-list').find('.slick-slide.active:not(:last-child)').removeClass('active').next().addClass('active').find('a').trigger('click');
        });
    });

    function sliderInit() {
        let windowWidth = $(window).outerWidth();
        $('.product-info-tabs').each(function(){
            if( windowWidth > 767 ) {
                $(this).find('.product-info-tabs__wrap .tab-list.slick-initialized').slick('unslick');
            } else {
                $(this).find('.product-info-tabs__wrap .tab-list:not(.slick-initialized)').slick({
                    dots: false,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    focusOnSelect: false,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                    ]
                });
            }
        });
    }

})(jQuery);

